import { render, staticRenderFns } from "./PriceDevelopmentInOriginalCurrency.vue?vue&type=template&id=eca0b2f6&"
import script from "./PriceDevelopmentInOriginalCurrency.vue?vue&type=script&lang=js&"
export * from "./PriceDevelopmentInOriginalCurrency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports